import { render, staticRenderFns } from "./AutoCheck.vue?vue&type=template&id=035b447b&scoped=true&"
import script from "./AutoCheck.vue?vue&type=script&lang=js&"
export * from "./AutoCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b447b",
  null
  
)

export default component.exports